/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as DevTokensRouteImport } from './routes/dev.tokens'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as AuthConfigErrorRouteImport } from './routes/auth.config-error'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthedInicioRouteImport } from './routes/_authed.inicio'
import { Route as AuthedCaixaDeEntradaRouteImport } from './routes/_authed.caixa-de-entrada'
import { Route as AuthedRelatoriosIndexRouteImport } from './routes/_authed.relatorios.index'
import { Route as AuthedRecebimentosIndexRouteImport } from './routes/_authed.recebimentos.index'
import { Route as AuthedPagamentosIndexRouteImport } from './routes/_authed.pagamentos.index'
import { Route as AuthedMaisOpcoesIndexRouteImport } from './routes/_authed.mais-opcoes.index'
import { Route as AuthedGestaoDeCaixaIndexRouteImport } from './routes/_authed.gestao-de-caixa.index'
import { Route as AuthedContatosIndexRouteImport } from './routes/_authed.contatos.index'
import { Route as AuthedConfiguracoesIndexRouteImport } from './routes/_authed.configuracoes.index'
import { Route as AuthedRelatoriosTransferenciasRouteImport } from './routes/_authed.relatorios.transferencias'
import { Route as AuthedRelatoriosPainelDeAcompanhamentoRouteImport } from './routes/_authed.relatorios.painel-de-acompanhamento'
import { Route as AuthedRelatoriosMaisRelatoriosRouteImport } from './routes/_authed.relatorios.mais-relatorios'
import { Route as AuthedRelatoriosContasRecebidasRouteImport } from './routes/_authed.relatorios.contas-recebidas'
import { Route as AuthedRelatoriosContasPagasRouteImport } from './routes/_authed.relatorios.contas-pagas'
import { Route as AuthedRelatoriosContasAReceberRouteImport } from './routes/_authed.relatorios.contas-a-receber'
import { Route as AuthedRelatoriosContasAPagarRouteImport } from './routes/_authed.relatorios.contas-a-pagar'
import { Route as AuthedRecebimentosParcelamentosRouteImport } from './routes/_authed.recebimentos.parcelamentos'
import { Route as AuthedRecebimentosNfseRouteImport } from './routes/_authed.recebimentos.nfse'
import { Route as AuthedRecebimentosCentralDeCobrancaRouteImport } from './routes/_authed.recebimentos.central-de-cobranca'
import { Route as AuthedRecebimentosBoletosRouteImport } from './routes/_authed.recebimentos.boletos'
import { Route as AuthedRecebimentosReceberRouteImport } from './routes/_authed.recebimentos._receber'
import { Route as AuthedPagamentosParcelamentosRouteImport } from './routes/_authed.pagamentos.parcelamentos'
import { Route as AuthedPagamentosPagarRouteImport } from './routes/_authed.pagamentos._pagar'
import { Route as AuthedMaisOpcoesHistoricoDeAtividadesRouteImport } from './routes/_authed.mais-opcoes.historico-de-atividades'
import { Route as AuthedMaisOpcoesFechamentoDeMesRouteImport } from './routes/_authed.mais-opcoes.fechamento-de-mes'
import { Route as AuthedGestaoDeCaixaResumoRouteImport } from './routes/_authed.gestao-de-caixa.resumo'
import { Route as AuthedGestaoDeCaixaFluxoDeCaixaRouteImport } from './routes/_authed.gestao-de-caixa.fluxo-de-caixa'
import { Route as AuthedGestaoDeCaixaContasEExtratosRouteImport } from './routes/_authed.gestao-de-caixa.contas-e-extratos'
import { Route as AuthedContatosSlugRouteImport } from './routes/_authed.contatos.$slug'
import { Route as AuthedConfiguracoesUsuariosRouteImport } from './routes/_authed.configuracoes.usuarios'
import { Route as AuthedConfiguracoesNfseRouteImport } from './routes/_authed.configuracoes.nfse'
import { Route as AuthedConfiguracoesIntegracoesRouteImport } from './routes/_authed.configuracoes.integracoes'
import { Route as AuthedConfiguracoesEmpresaRouteImport } from './routes/_authed.configuracoes.empresa'
import { Route as AuthedConfiguracoesCobrancaRouteImport } from './routes/_authed.configuracoes.cobranca'
import { Route as AuthedConfiguracoesCentrosDeCustoRouteImport } from './routes/_authed.configuracoes.centros-de-custo'
import { Route as AuthedConfiguracoesCategoriasRouteImport } from './routes/_authed.configuracoes.categorias'
import { Route as AuthedConfiguracoesAvancadoRouteImport } from './routes/_authed.configuracoes.avancado'
import { Route as AuthedRecebimentosReceberReceberRouteImport } from './routes/_authed.recebimentos._receber.receber'
import { Route as AuthedRecebimentosReceberAgendarRouteImport } from './routes/_authed.recebimentos._receber.agendar'
import { Route as AuthedPagamentosPagarPagarRouteImport } from './routes/_authed.pagamentos._pagar.pagar'
import { Route as AuthedPagamentosPagarAgendarRouteImport } from './routes/_authed.pagamentos._pagar.agendar'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const DevTokensRoute = DevTokensRouteImport.update({
  id: '/dev/tokens',
  path: '/dev/tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthConfigErrorRoute = AuthConfigErrorRouteImport.update({
  id: '/auth/config-error',
  path: '/auth/config-error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedInicioRoute = AuthedInicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCaixaDeEntradaRoute = AuthedCaixaDeEntradaRouteImport.update({
  id: '/caixa-de-entrada',
  path: '/caixa-de-entrada',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRelatoriosIndexRoute = AuthedRelatoriosIndexRouteImport.update({
  id: '/relatorios/',
  path: '/relatorios/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecebimentosIndexRoute = AuthedRecebimentosIndexRouteImport.update({
  id: '/recebimentos/',
  path: '/recebimentos/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPagamentosIndexRoute = AuthedPagamentosIndexRouteImport.update({
  id: '/pagamentos/',
  path: '/pagamentos/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMaisOpcoesIndexRoute = AuthedMaisOpcoesIndexRouteImport.update({
  id: '/mais-opcoes/',
  path: '/mais-opcoes/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGestaoDeCaixaIndexRoute =
  AuthedGestaoDeCaixaIndexRouteImport.update({
    id: '/gestao-de-caixa/',
    path: '/gestao-de-caixa/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedContatosIndexRoute = AuthedContatosIndexRouteImport.update({
  id: '/contatos/',
  path: '/contatos/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConfiguracoesIndexRoute =
  AuthedConfiguracoesIndexRouteImport.update({
    id: '/configuracoes/',
    path: '/configuracoes/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRelatoriosTransferenciasRoute =
  AuthedRelatoriosTransferenciasRouteImport.update({
    id: '/relatorios/transferencias',
    path: '/relatorios/transferencias',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRelatoriosPainelDeAcompanhamentoRoute =
  AuthedRelatoriosPainelDeAcompanhamentoRouteImport.update({
    id: '/relatorios/painel-de-acompanhamento',
    path: '/relatorios/painel-de-acompanhamento',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRelatoriosMaisRelatoriosRoute =
  AuthedRelatoriosMaisRelatoriosRouteImport.update({
    id: '/relatorios/mais-relatorios',
    path: '/relatorios/mais-relatorios',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRelatoriosContasRecebidasRoute =
  AuthedRelatoriosContasRecebidasRouteImport.update({
    id: '/relatorios/contas-recebidas',
    path: '/relatorios/contas-recebidas',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRelatoriosContasPagasRoute =
  AuthedRelatoriosContasPagasRouteImport.update({
    id: '/relatorios/contas-pagas',
    path: '/relatorios/contas-pagas',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRelatoriosContasAReceberRoute =
  AuthedRelatoriosContasAReceberRouteImport.update({
    id: '/relatorios/contas-a-receber',
    path: '/relatorios/contas-a-receber',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRelatoriosContasAPagarRoute =
  AuthedRelatoriosContasAPagarRouteImport.update({
    id: '/relatorios/contas-a-pagar',
    path: '/relatorios/contas-a-pagar',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRecebimentosParcelamentosRoute =
  AuthedRecebimentosParcelamentosRouteImport.update({
    id: '/recebimentos/parcelamentos',
    path: '/recebimentos/parcelamentos',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRecebimentosNfseRoute = AuthedRecebimentosNfseRouteImport.update({
  id: '/recebimentos/nfse',
  path: '/recebimentos/nfse',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecebimentosCentralDeCobrancaRoute =
  AuthedRecebimentosCentralDeCobrancaRouteImport.update({
    id: '/recebimentos/central-de-cobranca',
    path: '/recebimentos/central-de-cobranca',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRecebimentosBoletosRoute =
  AuthedRecebimentosBoletosRouteImport.update({
    id: '/recebimentos/boletos',
    path: '/recebimentos/boletos',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRecebimentosReceberRoute =
  AuthedRecebimentosReceberRouteImport.update({
    id: '/recebimentos/_receber',
    path: '/recebimentos',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPagamentosParcelamentosRoute =
  AuthedPagamentosParcelamentosRouteImport.update({
    id: '/pagamentos/parcelamentos',
    path: '/pagamentos/parcelamentos',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPagamentosPagarRoute = AuthedPagamentosPagarRouteImport.update({
  id: '/pagamentos/_pagar',
  path: '/pagamentos',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMaisOpcoesHistoricoDeAtividadesRoute =
  AuthedMaisOpcoesHistoricoDeAtividadesRouteImport.update({
    id: '/mais-opcoes/historico-de-atividades',
    path: '/mais-opcoes/historico-de-atividades',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMaisOpcoesFechamentoDeMesRoute =
  AuthedMaisOpcoesFechamentoDeMesRouteImport.update({
    id: '/mais-opcoes/fechamento-de-mes',
    path: '/mais-opcoes/fechamento-de-mes',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedGestaoDeCaixaResumoRoute =
  AuthedGestaoDeCaixaResumoRouteImport.update({
    id: '/gestao-de-caixa/resumo',
    path: '/gestao-de-caixa/resumo',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedGestaoDeCaixaFluxoDeCaixaRoute =
  AuthedGestaoDeCaixaFluxoDeCaixaRouteImport.update({
    id: '/gestao-de-caixa/fluxo-de-caixa',
    path: '/gestao-de-caixa/fluxo-de-caixa',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedGestaoDeCaixaContasEExtratosRoute =
  AuthedGestaoDeCaixaContasEExtratosRouteImport.update({
    id: '/gestao-de-caixa/contas-e-extratos',
    path: '/gestao-de-caixa/contas-e-extratos',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedContatosSlugRoute = AuthedContatosSlugRouteImport.update({
  id: '/contatos/$slug',
  path: '/contatos/$slug',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConfiguracoesUsuariosRoute =
  AuthedConfiguracoesUsuariosRouteImport.update({
    id: '/configuracoes/usuarios',
    path: '/configuracoes/usuarios',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConfiguracoesNfseRoute = AuthedConfiguracoesNfseRouteImport.update({
  id: '/configuracoes/nfse',
  path: '/configuracoes/nfse',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConfiguracoesIntegracoesRoute =
  AuthedConfiguracoesIntegracoesRouteImport.update({
    id: '/configuracoes/integracoes',
    path: '/configuracoes/integracoes',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConfiguracoesEmpresaRoute =
  AuthedConfiguracoesEmpresaRouteImport.update({
    id: '/configuracoes/empresa',
    path: '/configuracoes/empresa',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConfiguracoesCobrancaRoute =
  AuthedConfiguracoesCobrancaRouteImport.update({
    id: '/configuracoes/cobranca',
    path: '/configuracoes/cobranca',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConfiguracoesCentrosDeCustoRoute =
  AuthedConfiguracoesCentrosDeCustoRouteImport.update({
    id: '/configuracoes/centros-de-custo',
    path: '/configuracoes/centros-de-custo',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConfiguracoesCategoriasRoute =
  AuthedConfiguracoesCategoriasRouteImport.update({
    id: '/configuracoes/categorias',
    path: '/configuracoes/categorias',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConfiguracoesAvancadoRoute =
  AuthedConfiguracoesAvancadoRouteImport.update({
    id: '/configuracoes/avancado',
    path: '/configuracoes/avancado',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRecebimentosReceberReceberRoute =
  AuthedRecebimentosReceberReceberRouteImport.update({
    id: '/receber',
    path: '/receber',
    getParentRoute: () => AuthedRecebimentosReceberRoute,
  } as any)
const AuthedRecebimentosReceberAgendarRoute =
  AuthedRecebimentosReceberAgendarRouteImport.update({
    id: '/agendar',
    path: '/agendar',
    getParentRoute: () => AuthedRecebimentosReceberRoute,
  } as any)
const AuthedPagamentosPagarPagarRoute =
  AuthedPagamentosPagarPagarRouteImport.update({
    id: '/pagar',
    path: '/pagar',
    getParentRoute: () => AuthedPagamentosPagarRoute,
  } as any)
const AuthedPagamentosPagarAgendarRoute =
  AuthedPagamentosPagarAgendarRouteImport.update({
    id: '/agendar',
    path: '/agendar',
    getParentRoute: () => AuthedPagamentosPagarRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/caixa-de-entrada': typeof AuthedCaixaDeEntradaRoute
  '/inicio': typeof AuthedInicioRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/config-error': typeof AuthConfigErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/dev/tokens': typeof DevTokensRoute
  '/configuracoes/avancado': typeof AuthedConfiguracoesAvancadoRoute
  '/configuracoes/categorias': typeof AuthedConfiguracoesCategoriasRoute
  '/configuracoes/centros-de-custo': typeof AuthedConfiguracoesCentrosDeCustoRoute
  '/configuracoes/cobranca': typeof AuthedConfiguracoesCobrancaRoute
  '/configuracoes/empresa': typeof AuthedConfiguracoesEmpresaRoute
  '/configuracoes/integracoes': typeof AuthedConfiguracoesIntegracoesRoute
  '/configuracoes/nfse': typeof AuthedConfiguracoesNfseRoute
  '/configuracoes/usuarios': typeof AuthedConfiguracoesUsuariosRoute
  '/contatos/$slug': typeof AuthedContatosSlugRoute
  '/gestao-de-caixa/contas-e-extratos': typeof AuthedGestaoDeCaixaContasEExtratosRoute
  '/gestao-de-caixa/fluxo-de-caixa': typeof AuthedGestaoDeCaixaFluxoDeCaixaRoute
  '/gestao-de-caixa/resumo': typeof AuthedGestaoDeCaixaResumoRoute
  '/mais-opcoes/fechamento-de-mes': typeof AuthedMaisOpcoesFechamentoDeMesRoute
  '/mais-opcoes/historico-de-atividades': typeof AuthedMaisOpcoesHistoricoDeAtividadesRoute
  '/pagamentos': typeof AuthedPagamentosPagarRouteWithChildren
  '/pagamentos/parcelamentos': typeof AuthedPagamentosParcelamentosRoute
  '/recebimentos': typeof AuthedRecebimentosReceberRouteWithChildren
  '/recebimentos/boletos': typeof AuthedRecebimentosBoletosRoute
  '/recebimentos/central-de-cobranca': typeof AuthedRecebimentosCentralDeCobrancaRoute
  '/recebimentos/nfse': typeof AuthedRecebimentosNfseRoute
  '/recebimentos/parcelamentos': typeof AuthedRecebimentosParcelamentosRoute
  '/relatorios/contas-a-pagar': typeof AuthedRelatoriosContasAPagarRoute
  '/relatorios/contas-a-receber': typeof AuthedRelatoriosContasAReceberRoute
  '/relatorios/contas-pagas': typeof AuthedRelatoriosContasPagasRoute
  '/relatorios/contas-recebidas': typeof AuthedRelatoriosContasRecebidasRoute
  '/relatorios/mais-relatorios': typeof AuthedRelatoriosMaisRelatoriosRoute
  '/relatorios/painel-de-acompanhamento': typeof AuthedRelatoriosPainelDeAcompanhamentoRoute
  '/relatorios/transferencias': typeof AuthedRelatoriosTransferenciasRoute
  '/configuracoes/': typeof AuthedConfiguracoesIndexRoute
  '/contatos/': typeof AuthedContatosIndexRoute
  '/gestao-de-caixa/': typeof AuthedGestaoDeCaixaIndexRoute
  '/mais-opcoes/': typeof AuthedMaisOpcoesIndexRoute
  '/pagamentos/': typeof AuthedPagamentosIndexRoute
  '/recebimentos/': typeof AuthedRecebimentosIndexRoute
  '/relatorios/': typeof AuthedRelatoriosIndexRoute
  '/pagamentos/agendar': typeof AuthedPagamentosPagarAgendarRoute
  '/pagamentos/pagar': typeof AuthedPagamentosPagarPagarRoute
  '/recebimentos/agendar': typeof AuthedRecebimentosReceberAgendarRoute
  '/recebimentos/receber': typeof AuthedRecebimentosReceberReceberRoute
}
export interface FileRoutesByTo {
  '/caixa-de-entrada': typeof AuthedCaixaDeEntradaRoute
  '/inicio': typeof AuthedInicioRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/config-error': typeof AuthConfigErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/dev/tokens': typeof DevTokensRoute
  '/': typeof AuthedIndexRoute
  '/configuracoes/avancado': typeof AuthedConfiguracoesAvancadoRoute
  '/configuracoes/categorias': typeof AuthedConfiguracoesCategoriasRoute
  '/configuracoes/centros-de-custo': typeof AuthedConfiguracoesCentrosDeCustoRoute
  '/configuracoes/cobranca': typeof AuthedConfiguracoesCobrancaRoute
  '/configuracoes/empresa': typeof AuthedConfiguracoesEmpresaRoute
  '/configuracoes/integracoes': typeof AuthedConfiguracoesIntegracoesRoute
  '/configuracoes/nfse': typeof AuthedConfiguracoesNfseRoute
  '/configuracoes/usuarios': typeof AuthedConfiguracoesUsuariosRoute
  '/contatos/$slug': typeof AuthedContatosSlugRoute
  '/gestao-de-caixa/contas-e-extratos': typeof AuthedGestaoDeCaixaContasEExtratosRoute
  '/gestao-de-caixa/fluxo-de-caixa': typeof AuthedGestaoDeCaixaFluxoDeCaixaRoute
  '/gestao-de-caixa/resumo': typeof AuthedGestaoDeCaixaResumoRoute
  '/mais-opcoes/fechamento-de-mes': typeof AuthedMaisOpcoesFechamentoDeMesRoute
  '/mais-opcoes/historico-de-atividades': typeof AuthedMaisOpcoesHistoricoDeAtividadesRoute
  '/pagamentos': typeof AuthedPagamentosIndexRoute
  '/pagamentos/parcelamentos': typeof AuthedPagamentosParcelamentosRoute
  '/recebimentos': typeof AuthedRecebimentosIndexRoute
  '/recebimentos/boletos': typeof AuthedRecebimentosBoletosRoute
  '/recebimentos/central-de-cobranca': typeof AuthedRecebimentosCentralDeCobrancaRoute
  '/recebimentos/nfse': typeof AuthedRecebimentosNfseRoute
  '/recebimentos/parcelamentos': typeof AuthedRecebimentosParcelamentosRoute
  '/relatorios/contas-a-pagar': typeof AuthedRelatoriosContasAPagarRoute
  '/relatorios/contas-a-receber': typeof AuthedRelatoriosContasAReceberRoute
  '/relatorios/contas-pagas': typeof AuthedRelatoriosContasPagasRoute
  '/relatorios/contas-recebidas': typeof AuthedRelatoriosContasRecebidasRoute
  '/relatorios/mais-relatorios': typeof AuthedRelatoriosMaisRelatoriosRoute
  '/relatorios/painel-de-acompanhamento': typeof AuthedRelatoriosPainelDeAcompanhamentoRoute
  '/relatorios/transferencias': typeof AuthedRelatoriosTransferenciasRoute
  '/configuracoes': typeof AuthedConfiguracoesIndexRoute
  '/contatos': typeof AuthedContatosIndexRoute
  '/gestao-de-caixa': typeof AuthedGestaoDeCaixaIndexRoute
  '/mais-opcoes': typeof AuthedMaisOpcoesIndexRoute
  '/relatorios': typeof AuthedRelatoriosIndexRoute
  '/pagamentos/agendar': typeof AuthedPagamentosPagarAgendarRoute
  '/pagamentos/pagar': typeof AuthedPagamentosPagarPagarRoute
  '/recebimentos/agendar': typeof AuthedRecebimentosReceberAgendarRoute
  '/recebimentos/receber': typeof AuthedRecebimentosReceberReceberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_authed/caixa-de-entrada': typeof AuthedCaixaDeEntradaRoute
  '/_authed/inicio': typeof AuthedInicioRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/config-error': typeof AuthConfigErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/dev/tokens': typeof DevTokensRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/configuracoes/avancado': typeof AuthedConfiguracoesAvancadoRoute
  '/_authed/configuracoes/categorias': typeof AuthedConfiguracoesCategoriasRoute
  '/_authed/configuracoes/centros-de-custo': typeof AuthedConfiguracoesCentrosDeCustoRoute
  '/_authed/configuracoes/cobranca': typeof AuthedConfiguracoesCobrancaRoute
  '/_authed/configuracoes/empresa': typeof AuthedConfiguracoesEmpresaRoute
  '/_authed/configuracoes/integracoes': typeof AuthedConfiguracoesIntegracoesRoute
  '/_authed/configuracoes/nfse': typeof AuthedConfiguracoesNfseRoute
  '/_authed/configuracoes/usuarios': typeof AuthedConfiguracoesUsuariosRoute
  '/_authed/contatos/$slug': typeof AuthedContatosSlugRoute
  '/_authed/gestao-de-caixa/contas-e-extratos': typeof AuthedGestaoDeCaixaContasEExtratosRoute
  '/_authed/gestao-de-caixa/fluxo-de-caixa': typeof AuthedGestaoDeCaixaFluxoDeCaixaRoute
  '/_authed/gestao-de-caixa/resumo': typeof AuthedGestaoDeCaixaResumoRoute
  '/_authed/mais-opcoes/fechamento-de-mes': typeof AuthedMaisOpcoesFechamentoDeMesRoute
  '/_authed/mais-opcoes/historico-de-atividades': typeof AuthedMaisOpcoesHistoricoDeAtividadesRoute
  '/_authed/pagamentos/_pagar': typeof AuthedPagamentosPagarRouteWithChildren
  '/_authed/pagamentos/parcelamentos': typeof AuthedPagamentosParcelamentosRoute
  '/_authed/recebimentos/_receber': typeof AuthedRecebimentosReceberRouteWithChildren
  '/_authed/recebimentos/boletos': typeof AuthedRecebimentosBoletosRoute
  '/_authed/recebimentos/central-de-cobranca': typeof AuthedRecebimentosCentralDeCobrancaRoute
  '/_authed/recebimentos/nfse': typeof AuthedRecebimentosNfseRoute
  '/_authed/recebimentos/parcelamentos': typeof AuthedRecebimentosParcelamentosRoute
  '/_authed/relatorios/contas-a-pagar': typeof AuthedRelatoriosContasAPagarRoute
  '/_authed/relatorios/contas-a-receber': typeof AuthedRelatoriosContasAReceberRoute
  '/_authed/relatorios/contas-pagas': typeof AuthedRelatoriosContasPagasRoute
  '/_authed/relatorios/contas-recebidas': typeof AuthedRelatoriosContasRecebidasRoute
  '/_authed/relatorios/mais-relatorios': typeof AuthedRelatoriosMaisRelatoriosRoute
  '/_authed/relatorios/painel-de-acompanhamento': typeof AuthedRelatoriosPainelDeAcompanhamentoRoute
  '/_authed/relatorios/transferencias': typeof AuthedRelatoriosTransferenciasRoute
  '/_authed/configuracoes/': typeof AuthedConfiguracoesIndexRoute
  '/_authed/contatos/': typeof AuthedContatosIndexRoute
  '/_authed/gestao-de-caixa/': typeof AuthedGestaoDeCaixaIndexRoute
  '/_authed/mais-opcoes/': typeof AuthedMaisOpcoesIndexRoute
  '/_authed/pagamentos/': typeof AuthedPagamentosIndexRoute
  '/_authed/recebimentos/': typeof AuthedRecebimentosIndexRoute
  '/_authed/relatorios/': typeof AuthedRelatoriosIndexRoute
  '/_authed/pagamentos/_pagar/agendar': typeof AuthedPagamentosPagarAgendarRoute
  '/_authed/pagamentos/_pagar/pagar': typeof AuthedPagamentosPagarPagarRoute
  '/_authed/recebimentos/_receber/agendar': typeof AuthedRecebimentosReceberAgendarRoute
  '/_authed/recebimentos/_receber/receber': typeof AuthedRecebimentosReceberReceberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/caixa-de-entrada'
    | '/inicio'
    | '/auth/callback'
    | '/auth/config-error'
    | '/auth/login'
    | '/dev/tokens'
    | '/configuracoes/avancado'
    | '/configuracoes/categorias'
    | '/configuracoes/centros-de-custo'
    | '/configuracoes/cobranca'
    | '/configuracoes/empresa'
    | '/configuracoes/integracoes'
    | '/configuracoes/nfse'
    | '/configuracoes/usuarios'
    | '/contatos/$slug'
    | '/gestao-de-caixa/contas-e-extratos'
    | '/gestao-de-caixa/fluxo-de-caixa'
    | '/gestao-de-caixa/resumo'
    | '/mais-opcoes/fechamento-de-mes'
    | '/mais-opcoes/historico-de-atividades'
    | '/pagamentos'
    | '/pagamentos/parcelamentos'
    | '/recebimentos'
    | '/recebimentos/boletos'
    | '/recebimentos/central-de-cobranca'
    | '/recebimentos/nfse'
    | '/recebimentos/parcelamentos'
    | '/relatorios/contas-a-pagar'
    | '/relatorios/contas-a-receber'
    | '/relatorios/contas-pagas'
    | '/relatorios/contas-recebidas'
    | '/relatorios/mais-relatorios'
    | '/relatorios/painel-de-acompanhamento'
    | '/relatorios/transferencias'
    | '/configuracoes/'
    | '/contatos/'
    | '/gestao-de-caixa/'
    | '/mais-opcoes/'
    | '/pagamentos/'
    | '/recebimentos/'
    | '/relatorios/'
    | '/pagamentos/agendar'
    | '/pagamentos/pagar'
    | '/recebimentos/agendar'
    | '/recebimentos/receber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/caixa-de-entrada'
    | '/inicio'
    | '/auth/callback'
    | '/auth/config-error'
    | '/auth/login'
    | '/dev/tokens'
    | '/'
    | '/configuracoes/avancado'
    | '/configuracoes/categorias'
    | '/configuracoes/centros-de-custo'
    | '/configuracoes/cobranca'
    | '/configuracoes/empresa'
    | '/configuracoes/integracoes'
    | '/configuracoes/nfse'
    | '/configuracoes/usuarios'
    | '/contatos/$slug'
    | '/gestao-de-caixa/contas-e-extratos'
    | '/gestao-de-caixa/fluxo-de-caixa'
    | '/gestao-de-caixa/resumo'
    | '/mais-opcoes/fechamento-de-mes'
    | '/mais-opcoes/historico-de-atividades'
    | '/pagamentos'
    | '/pagamentos/parcelamentos'
    | '/recebimentos'
    | '/recebimentos/boletos'
    | '/recebimentos/central-de-cobranca'
    | '/recebimentos/nfse'
    | '/recebimentos/parcelamentos'
    | '/relatorios/contas-a-pagar'
    | '/relatorios/contas-a-receber'
    | '/relatorios/contas-pagas'
    | '/relatorios/contas-recebidas'
    | '/relatorios/mais-relatorios'
    | '/relatorios/painel-de-acompanhamento'
    | '/relatorios/transferencias'
    | '/configuracoes'
    | '/contatos'
    | '/gestao-de-caixa'
    | '/mais-opcoes'
    | '/relatorios'
    | '/pagamentos/agendar'
    | '/pagamentos/pagar'
    | '/recebimentos/agendar'
    | '/recebimentos/receber'
  id:
    | '__root__'
    | '/_authed'
    | '/_authed/caixa-de-entrada'
    | '/_authed/inicio'
    | '/auth/callback'
    | '/auth/config-error'
    | '/auth/login'
    | '/dev/tokens'
    | '/_authed/'
    | '/_authed/configuracoes/avancado'
    | '/_authed/configuracoes/categorias'
    | '/_authed/configuracoes/centros-de-custo'
    | '/_authed/configuracoes/cobranca'
    | '/_authed/configuracoes/empresa'
    | '/_authed/configuracoes/integracoes'
    | '/_authed/configuracoes/nfse'
    | '/_authed/configuracoes/usuarios'
    | '/_authed/contatos/$slug'
    | '/_authed/gestao-de-caixa/contas-e-extratos'
    | '/_authed/gestao-de-caixa/fluxo-de-caixa'
    | '/_authed/gestao-de-caixa/resumo'
    | '/_authed/mais-opcoes/fechamento-de-mes'
    | '/_authed/mais-opcoes/historico-de-atividades'
    | '/_authed/pagamentos/_pagar'
    | '/_authed/pagamentos/parcelamentos'
    | '/_authed/recebimentos/_receber'
    | '/_authed/recebimentos/boletos'
    | '/_authed/recebimentos/central-de-cobranca'
    | '/_authed/recebimentos/nfse'
    | '/_authed/recebimentos/parcelamentos'
    | '/_authed/relatorios/contas-a-pagar'
    | '/_authed/relatorios/contas-a-receber'
    | '/_authed/relatorios/contas-pagas'
    | '/_authed/relatorios/contas-recebidas'
    | '/_authed/relatorios/mais-relatorios'
    | '/_authed/relatorios/painel-de-acompanhamento'
    | '/_authed/relatorios/transferencias'
    | '/_authed/configuracoes/'
    | '/_authed/contatos/'
    | '/_authed/gestao-de-caixa/'
    | '/_authed/mais-opcoes/'
    | '/_authed/pagamentos/'
    | '/_authed/recebimentos/'
    | '/_authed/relatorios/'
    | '/_authed/pagamentos/_pagar/agendar'
    | '/_authed/pagamentos/_pagar/pagar'
    | '/_authed/recebimentos/_receber/agendar'
    | '/_authed/recebimentos/_receber/receber'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthConfigErrorRoute: typeof AuthConfigErrorRoute
  AuthLoginRoute: typeof AuthLoginRoute
  DevTokensRoute: typeof DevTokensRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/dev/tokens': {
      id: '/dev/tokens'
      path: '/dev/tokens'
      fullPath: '/dev/tokens'
      preLoaderRoute: typeof DevTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/config-error': {
      id: '/auth/config-error'
      path: '/auth/config-error'
      fullPath: '/auth/config-error'
      preLoaderRoute: typeof AuthConfigErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/inicio': {
      id: '/_authed/inicio'
      path: '/inicio'
      fullPath: '/inicio'
      preLoaderRoute: typeof AuthedInicioRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/caixa-de-entrada': {
      id: '/_authed/caixa-de-entrada'
      path: '/caixa-de-entrada'
      fullPath: '/caixa-de-entrada'
      preLoaderRoute: typeof AuthedCaixaDeEntradaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/relatorios/': {
      id: '/_authed/relatorios/'
      path: '/relatorios'
      fullPath: '/relatorios/'
      preLoaderRoute: typeof AuthedRelatoriosIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recebimentos/': {
      id: '/_authed/recebimentos/'
      path: '/recebimentos'
      fullPath: '/recebimentos/'
      preLoaderRoute: typeof AuthedRecebimentosIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pagamentos/': {
      id: '/_authed/pagamentos/'
      path: '/pagamentos'
      fullPath: '/pagamentos/'
      preLoaderRoute: typeof AuthedPagamentosIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/mais-opcoes/': {
      id: '/_authed/mais-opcoes/'
      path: '/mais-opcoes'
      fullPath: '/mais-opcoes/'
      preLoaderRoute: typeof AuthedMaisOpcoesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gestao-de-caixa/': {
      id: '/_authed/gestao-de-caixa/'
      path: '/gestao-de-caixa'
      fullPath: '/gestao-de-caixa/'
      preLoaderRoute: typeof AuthedGestaoDeCaixaIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/contatos/': {
      id: '/_authed/contatos/'
      path: '/contatos'
      fullPath: '/contatos/'
      preLoaderRoute: typeof AuthedContatosIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/': {
      id: '/_authed/configuracoes/'
      path: '/configuracoes'
      fullPath: '/configuracoes/'
      preLoaderRoute: typeof AuthedConfiguracoesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/relatorios/transferencias': {
      id: '/_authed/relatorios/transferencias'
      path: '/relatorios/transferencias'
      fullPath: '/relatorios/transferencias'
      preLoaderRoute: typeof AuthedRelatoriosTransferenciasRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/relatorios/painel-de-acompanhamento': {
      id: '/_authed/relatorios/painel-de-acompanhamento'
      path: '/relatorios/painel-de-acompanhamento'
      fullPath: '/relatorios/painel-de-acompanhamento'
      preLoaderRoute: typeof AuthedRelatoriosPainelDeAcompanhamentoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/relatorios/mais-relatorios': {
      id: '/_authed/relatorios/mais-relatorios'
      path: '/relatorios/mais-relatorios'
      fullPath: '/relatorios/mais-relatorios'
      preLoaderRoute: typeof AuthedRelatoriosMaisRelatoriosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/relatorios/contas-recebidas': {
      id: '/_authed/relatorios/contas-recebidas'
      path: '/relatorios/contas-recebidas'
      fullPath: '/relatorios/contas-recebidas'
      preLoaderRoute: typeof AuthedRelatoriosContasRecebidasRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/relatorios/contas-pagas': {
      id: '/_authed/relatorios/contas-pagas'
      path: '/relatorios/contas-pagas'
      fullPath: '/relatorios/contas-pagas'
      preLoaderRoute: typeof AuthedRelatoriosContasPagasRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/relatorios/contas-a-receber': {
      id: '/_authed/relatorios/contas-a-receber'
      path: '/relatorios/contas-a-receber'
      fullPath: '/relatorios/contas-a-receber'
      preLoaderRoute: typeof AuthedRelatoriosContasAReceberRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/relatorios/contas-a-pagar': {
      id: '/_authed/relatorios/contas-a-pagar'
      path: '/relatorios/contas-a-pagar'
      fullPath: '/relatorios/contas-a-pagar'
      preLoaderRoute: typeof AuthedRelatoriosContasAPagarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recebimentos/parcelamentos': {
      id: '/_authed/recebimentos/parcelamentos'
      path: '/recebimentos/parcelamentos'
      fullPath: '/recebimentos/parcelamentos'
      preLoaderRoute: typeof AuthedRecebimentosParcelamentosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recebimentos/nfse': {
      id: '/_authed/recebimentos/nfse'
      path: '/recebimentos/nfse'
      fullPath: '/recebimentos/nfse'
      preLoaderRoute: typeof AuthedRecebimentosNfseRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recebimentos/central-de-cobranca': {
      id: '/_authed/recebimentos/central-de-cobranca'
      path: '/recebimentos/central-de-cobranca'
      fullPath: '/recebimentos/central-de-cobranca'
      preLoaderRoute: typeof AuthedRecebimentosCentralDeCobrancaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recebimentos/boletos': {
      id: '/_authed/recebimentos/boletos'
      path: '/recebimentos/boletos'
      fullPath: '/recebimentos/boletos'
      preLoaderRoute: typeof AuthedRecebimentosBoletosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recebimentos/_receber': {
      id: '/_authed/recebimentos/_receber'
      path: '/recebimentos'
      fullPath: '/recebimentos'
      preLoaderRoute: typeof AuthedRecebimentosReceberRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pagamentos/parcelamentos': {
      id: '/_authed/pagamentos/parcelamentos'
      path: '/pagamentos/parcelamentos'
      fullPath: '/pagamentos/parcelamentos'
      preLoaderRoute: typeof AuthedPagamentosParcelamentosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pagamentos/_pagar': {
      id: '/_authed/pagamentos/_pagar'
      path: '/pagamentos'
      fullPath: '/pagamentos'
      preLoaderRoute: typeof AuthedPagamentosPagarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/mais-opcoes/historico-de-atividades': {
      id: '/_authed/mais-opcoes/historico-de-atividades'
      path: '/mais-opcoes/historico-de-atividades'
      fullPath: '/mais-opcoes/historico-de-atividades'
      preLoaderRoute: typeof AuthedMaisOpcoesHistoricoDeAtividadesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/mais-opcoes/fechamento-de-mes': {
      id: '/_authed/mais-opcoes/fechamento-de-mes'
      path: '/mais-opcoes/fechamento-de-mes'
      fullPath: '/mais-opcoes/fechamento-de-mes'
      preLoaderRoute: typeof AuthedMaisOpcoesFechamentoDeMesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gestao-de-caixa/resumo': {
      id: '/_authed/gestao-de-caixa/resumo'
      path: '/gestao-de-caixa/resumo'
      fullPath: '/gestao-de-caixa/resumo'
      preLoaderRoute: typeof AuthedGestaoDeCaixaResumoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gestao-de-caixa/fluxo-de-caixa': {
      id: '/_authed/gestao-de-caixa/fluxo-de-caixa'
      path: '/gestao-de-caixa/fluxo-de-caixa'
      fullPath: '/gestao-de-caixa/fluxo-de-caixa'
      preLoaderRoute: typeof AuthedGestaoDeCaixaFluxoDeCaixaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gestao-de-caixa/contas-e-extratos': {
      id: '/_authed/gestao-de-caixa/contas-e-extratos'
      path: '/gestao-de-caixa/contas-e-extratos'
      fullPath: '/gestao-de-caixa/contas-e-extratos'
      preLoaderRoute: typeof AuthedGestaoDeCaixaContasEExtratosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/contatos/$slug': {
      id: '/_authed/contatos/$slug'
      path: '/contatos/$slug'
      fullPath: '/contatos/$slug'
      preLoaderRoute: typeof AuthedContatosSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/usuarios': {
      id: '/_authed/configuracoes/usuarios'
      path: '/configuracoes/usuarios'
      fullPath: '/configuracoes/usuarios'
      preLoaderRoute: typeof AuthedConfiguracoesUsuariosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/nfse': {
      id: '/_authed/configuracoes/nfse'
      path: '/configuracoes/nfse'
      fullPath: '/configuracoes/nfse'
      preLoaderRoute: typeof AuthedConfiguracoesNfseRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/integracoes': {
      id: '/_authed/configuracoes/integracoes'
      path: '/configuracoes/integracoes'
      fullPath: '/configuracoes/integracoes'
      preLoaderRoute: typeof AuthedConfiguracoesIntegracoesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/empresa': {
      id: '/_authed/configuracoes/empresa'
      path: '/configuracoes/empresa'
      fullPath: '/configuracoes/empresa'
      preLoaderRoute: typeof AuthedConfiguracoesEmpresaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/cobranca': {
      id: '/_authed/configuracoes/cobranca'
      path: '/configuracoes/cobranca'
      fullPath: '/configuracoes/cobranca'
      preLoaderRoute: typeof AuthedConfiguracoesCobrancaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/centros-de-custo': {
      id: '/_authed/configuracoes/centros-de-custo'
      path: '/configuracoes/centros-de-custo'
      fullPath: '/configuracoes/centros-de-custo'
      preLoaderRoute: typeof AuthedConfiguracoesCentrosDeCustoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/categorias': {
      id: '/_authed/configuracoes/categorias'
      path: '/configuracoes/categorias'
      fullPath: '/configuracoes/categorias'
      preLoaderRoute: typeof AuthedConfiguracoesCategoriasRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/avancado': {
      id: '/_authed/configuracoes/avancado'
      path: '/configuracoes/avancado'
      fullPath: '/configuracoes/avancado'
      preLoaderRoute: typeof AuthedConfiguracoesAvancadoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recebimentos/_receber/receber': {
      id: '/_authed/recebimentos/_receber/receber'
      path: '/receber'
      fullPath: '/recebimentos/receber'
      preLoaderRoute: typeof AuthedRecebimentosReceberReceberRouteImport
      parentRoute: typeof AuthedRecebimentosReceberRoute
    }
    '/_authed/recebimentos/_receber/agendar': {
      id: '/_authed/recebimentos/_receber/agendar'
      path: '/agendar'
      fullPath: '/recebimentos/agendar'
      preLoaderRoute: typeof AuthedRecebimentosReceberAgendarRouteImport
      parentRoute: typeof AuthedRecebimentosReceberRoute
    }
    '/_authed/pagamentos/_pagar/pagar': {
      id: '/_authed/pagamentos/_pagar/pagar'
      path: '/pagar'
      fullPath: '/pagamentos/pagar'
      preLoaderRoute: typeof AuthedPagamentosPagarPagarRouteImport
      parentRoute: typeof AuthedPagamentosPagarRoute
    }
    '/_authed/pagamentos/_pagar/agendar': {
      id: '/_authed/pagamentos/_pagar/agendar'
      path: '/agendar'
      fullPath: '/pagamentos/agendar'
      preLoaderRoute: typeof AuthedPagamentosPagarAgendarRouteImport
      parentRoute: typeof AuthedPagamentosPagarRoute
    }
  }
}

interface AuthedPagamentosPagarRouteChildren {
  AuthedPagamentosPagarAgendarRoute: typeof AuthedPagamentosPagarAgendarRoute
  AuthedPagamentosPagarPagarRoute: typeof AuthedPagamentosPagarPagarRoute
}

const AuthedPagamentosPagarRouteChildren: AuthedPagamentosPagarRouteChildren = {
  AuthedPagamentosPagarAgendarRoute: AuthedPagamentosPagarAgendarRoute,
  AuthedPagamentosPagarPagarRoute: AuthedPagamentosPagarPagarRoute,
}

const AuthedPagamentosPagarRouteWithChildren =
  AuthedPagamentosPagarRoute._addFileChildren(
    AuthedPagamentosPagarRouteChildren,
  )

interface AuthedRecebimentosReceberRouteChildren {
  AuthedRecebimentosReceberAgendarRoute: typeof AuthedRecebimentosReceberAgendarRoute
  AuthedRecebimentosReceberReceberRoute: typeof AuthedRecebimentosReceberReceberRoute
}

const AuthedRecebimentosReceberRouteChildren: AuthedRecebimentosReceberRouteChildren =
  {
    AuthedRecebimentosReceberAgendarRoute:
      AuthedRecebimentosReceberAgendarRoute,
    AuthedRecebimentosReceberReceberRoute:
      AuthedRecebimentosReceberReceberRoute,
  }

const AuthedRecebimentosReceberRouteWithChildren =
  AuthedRecebimentosReceberRoute._addFileChildren(
    AuthedRecebimentosReceberRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedCaixaDeEntradaRoute: typeof AuthedCaixaDeEntradaRoute
  AuthedInicioRoute: typeof AuthedInicioRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedConfiguracoesAvancadoRoute: typeof AuthedConfiguracoesAvancadoRoute
  AuthedConfiguracoesCategoriasRoute: typeof AuthedConfiguracoesCategoriasRoute
  AuthedConfiguracoesCentrosDeCustoRoute: typeof AuthedConfiguracoesCentrosDeCustoRoute
  AuthedConfiguracoesCobrancaRoute: typeof AuthedConfiguracoesCobrancaRoute
  AuthedConfiguracoesEmpresaRoute: typeof AuthedConfiguracoesEmpresaRoute
  AuthedConfiguracoesIntegracoesRoute: typeof AuthedConfiguracoesIntegracoesRoute
  AuthedConfiguracoesNfseRoute: typeof AuthedConfiguracoesNfseRoute
  AuthedConfiguracoesUsuariosRoute: typeof AuthedConfiguracoesUsuariosRoute
  AuthedContatosSlugRoute: typeof AuthedContatosSlugRoute
  AuthedGestaoDeCaixaContasEExtratosRoute: typeof AuthedGestaoDeCaixaContasEExtratosRoute
  AuthedGestaoDeCaixaFluxoDeCaixaRoute: typeof AuthedGestaoDeCaixaFluxoDeCaixaRoute
  AuthedGestaoDeCaixaResumoRoute: typeof AuthedGestaoDeCaixaResumoRoute
  AuthedMaisOpcoesFechamentoDeMesRoute: typeof AuthedMaisOpcoesFechamentoDeMesRoute
  AuthedMaisOpcoesHistoricoDeAtividadesRoute: typeof AuthedMaisOpcoesHistoricoDeAtividadesRoute
  AuthedPagamentosPagarRoute: typeof AuthedPagamentosPagarRouteWithChildren
  AuthedPagamentosParcelamentosRoute: typeof AuthedPagamentosParcelamentosRoute
  AuthedRecebimentosReceberRoute: typeof AuthedRecebimentosReceberRouteWithChildren
  AuthedRecebimentosBoletosRoute: typeof AuthedRecebimentosBoletosRoute
  AuthedRecebimentosCentralDeCobrancaRoute: typeof AuthedRecebimentosCentralDeCobrancaRoute
  AuthedRecebimentosNfseRoute: typeof AuthedRecebimentosNfseRoute
  AuthedRecebimentosParcelamentosRoute: typeof AuthedRecebimentosParcelamentosRoute
  AuthedRelatoriosContasAPagarRoute: typeof AuthedRelatoriosContasAPagarRoute
  AuthedRelatoriosContasAReceberRoute: typeof AuthedRelatoriosContasAReceberRoute
  AuthedRelatoriosContasPagasRoute: typeof AuthedRelatoriosContasPagasRoute
  AuthedRelatoriosContasRecebidasRoute: typeof AuthedRelatoriosContasRecebidasRoute
  AuthedRelatoriosMaisRelatoriosRoute: typeof AuthedRelatoriosMaisRelatoriosRoute
  AuthedRelatoriosPainelDeAcompanhamentoRoute: typeof AuthedRelatoriosPainelDeAcompanhamentoRoute
  AuthedRelatoriosTransferenciasRoute: typeof AuthedRelatoriosTransferenciasRoute
  AuthedConfiguracoesIndexRoute: typeof AuthedConfiguracoesIndexRoute
  AuthedContatosIndexRoute: typeof AuthedContatosIndexRoute
  AuthedGestaoDeCaixaIndexRoute: typeof AuthedGestaoDeCaixaIndexRoute
  AuthedMaisOpcoesIndexRoute: typeof AuthedMaisOpcoesIndexRoute
  AuthedPagamentosIndexRoute: typeof AuthedPagamentosIndexRoute
  AuthedRecebimentosIndexRoute: typeof AuthedRecebimentosIndexRoute
  AuthedRelatoriosIndexRoute: typeof AuthedRelatoriosIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedCaixaDeEntradaRoute: AuthedCaixaDeEntradaRoute,
  AuthedInicioRoute: AuthedInicioRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedConfiguracoesAvancadoRoute: AuthedConfiguracoesAvancadoRoute,
  AuthedConfiguracoesCategoriasRoute: AuthedConfiguracoesCategoriasRoute,
  AuthedConfiguracoesCentrosDeCustoRoute:
    AuthedConfiguracoesCentrosDeCustoRoute,
  AuthedConfiguracoesCobrancaRoute: AuthedConfiguracoesCobrancaRoute,
  AuthedConfiguracoesEmpresaRoute: AuthedConfiguracoesEmpresaRoute,
  AuthedConfiguracoesIntegracoesRoute: AuthedConfiguracoesIntegracoesRoute,
  AuthedConfiguracoesNfseRoute: AuthedConfiguracoesNfseRoute,
  AuthedConfiguracoesUsuariosRoute: AuthedConfiguracoesUsuariosRoute,
  AuthedContatosSlugRoute: AuthedContatosSlugRoute,
  AuthedGestaoDeCaixaContasEExtratosRoute:
    AuthedGestaoDeCaixaContasEExtratosRoute,
  AuthedGestaoDeCaixaFluxoDeCaixaRoute: AuthedGestaoDeCaixaFluxoDeCaixaRoute,
  AuthedGestaoDeCaixaResumoRoute: AuthedGestaoDeCaixaResumoRoute,
  AuthedMaisOpcoesFechamentoDeMesRoute: AuthedMaisOpcoesFechamentoDeMesRoute,
  AuthedMaisOpcoesHistoricoDeAtividadesRoute:
    AuthedMaisOpcoesHistoricoDeAtividadesRoute,
  AuthedPagamentosPagarRoute: AuthedPagamentosPagarRouteWithChildren,
  AuthedPagamentosParcelamentosRoute: AuthedPagamentosParcelamentosRoute,
  AuthedRecebimentosReceberRoute: AuthedRecebimentosReceberRouteWithChildren,
  AuthedRecebimentosBoletosRoute: AuthedRecebimentosBoletosRoute,
  AuthedRecebimentosCentralDeCobrancaRoute:
    AuthedRecebimentosCentralDeCobrancaRoute,
  AuthedRecebimentosNfseRoute: AuthedRecebimentosNfseRoute,
  AuthedRecebimentosParcelamentosRoute: AuthedRecebimentosParcelamentosRoute,
  AuthedRelatoriosContasAPagarRoute: AuthedRelatoriosContasAPagarRoute,
  AuthedRelatoriosContasAReceberRoute: AuthedRelatoriosContasAReceberRoute,
  AuthedRelatoriosContasPagasRoute: AuthedRelatoriosContasPagasRoute,
  AuthedRelatoriosContasRecebidasRoute: AuthedRelatoriosContasRecebidasRoute,
  AuthedRelatoriosMaisRelatoriosRoute: AuthedRelatoriosMaisRelatoriosRoute,
  AuthedRelatoriosPainelDeAcompanhamentoRoute:
    AuthedRelatoriosPainelDeAcompanhamentoRoute,
  AuthedRelatoriosTransferenciasRoute: AuthedRelatoriosTransferenciasRoute,
  AuthedConfiguracoesIndexRoute: AuthedConfiguracoesIndexRoute,
  AuthedContatosIndexRoute: AuthedContatosIndexRoute,
  AuthedGestaoDeCaixaIndexRoute: AuthedGestaoDeCaixaIndexRoute,
  AuthedMaisOpcoesIndexRoute: AuthedMaisOpcoesIndexRoute,
  AuthedPagamentosIndexRoute: AuthedPagamentosIndexRoute,
  AuthedRecebimentosIndexRoute: AuthedRecebimentosIndexRoute,
  AuthedRelatoriosIndexRoute: AuthedRelatoriosIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthConfigErrorRoute: AuthConfigErrorRoute,
  AuthLoginRoute: AuthLoginRoute,
  DevTokensRoute: DevTokensRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
